import {set, observable, action, autorun} from 'mobx';
import {postData, formatElementsforExport} from '../utils/Utils';

import ElementModel from '../models/ElementModel'

export default class ElementStore {
    constructor(store) {
        this.store = store;

        //for storing incomplete responses
        autorun(() => {

            let data = {
                responseId: this.store.responseID,
                branchId: this.store.appConfig.branchId,
                tableName: (this.store.environment === 'staging') ? "mycampus_elems_test" : 'mycampus_elems',
                mapData: {
                    elements: []
                }
            };

            data.mapData.elements = formatElementsforExport(this.elements);

            let stagingURL = 'https://dj3mppbaa4.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda_staging/myc-s3-lambda-staging-incompleteresponses';
            let productionURL = 'https://23tkwzjvr2.execute-api.us-east-1.amazonaws.com/myc_postdata_s3_lambda_incomplete_responses/myc-s3-lambda-incompleteresponses';

            postData((this.store.environment === 'production') ? productionURL : stagingURL, JSON.stringify(data), (response) => {
                console.log(response);
            });


        }, {
            delay: 300,
            onError: (e) => {
                console.log('mobx error:autorun: ', e);
            }
        });
    }

    @observable elements = [];

    @action addElement(newElement) {
        this.elements.push(newElement);
        return newElement;
    }

    @action updateElement(uuid, data){
        let elementIndex = this.elements.findIndex(element => element.uuid === uuid);
        this.elements[elementIndex] = Object.assign({}, this.elements[elementIndex], data);
    }

    @action removeElement(uuid) {
        this.elements = this.elements.filter(element => element.uuid !== uuid);
    }

    @action createNewElement(icon, position){
        let element = Object.assign({}, new ElementModel(icon, position));
        this.makePendingElement(element);
        return element;
    }

    @action makePendingElement(element, editing=false){
        set(this.store.pendingState, {element: Object.assign({}, element)});
        this.store.pendingState.editing = editing;
    }

    isNotPending(element){
        if (!this.store.pendingState.element){
            return true;
        } else if (element.uuid === this.store.pendingState.element.uuid){
            return false;
        }
        return true;
    }

    inStore(newElement){
        return this.elements.findIndex(element => element.uuid === newElement.uuid) !== -1;
    }
}


// WEBPACK FOOTER //
// ./src/stores/ElementStore.js